const initialState = {
  list: [],
  purchaseOrders: [],
  rawMaterialTemplates: [],
  rooms: [],

  purchaseOrdersForReceive: [],
  purchaseOrdersForReceiveLoading: 'idle',

  rawMaterialTemplatesLoading: 'idle',
  purchaseOrdersLoading: 'idle',
  roomsLoading: 'idle',

  minimumStockLevelLoading: 'idle',

  editRawMaterialForm: {
    rawMaterialIdForEdit: null,
    loading: 'idle',
  },

  loading: 'idle',
};

export default initialState;
